import $$ from 'cmn-utils'

const baseUrl = "/api/grid/total/";
export default {
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },
}